import "core-js/modules/es6.string.fixed";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import { asyncRouterMap, constantRoutes } from '@/router';

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  return roles.includes(route.name);
}
function hasSamePermission(routeRole, userRole) {
  //临时数组存放
  var tempArray1 = []; //临时数组1
  var tempArray2 = []; //临时数组2

  for (var i = 0; i < routeRole.length; i++) {
    tempArray1[routeRole[i]] = true; //将数routeRole 中的元素值作为tempArray1 中的键，值为true；
  }
  for (var i = 0; i < userRole.length; i++) {
    if (tempArray1[userRole[i]]) {
      tempArray2.push(userRole[i]); //过滤array1 中与array2 相同的元素；
    }
  }
  console.log("tempArray2", tempArray2);
  console.log("tempArray2", routeRole, userRole);
  return tempArray2.length > 0;
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, roles, role, account_type) {
  var accessedRouters = asyncRouterMap.filter(function (route) {
    if (route.isLeader) {
      //只有白名单可以看
      if (account_type == 100) {
        if (route.children && route.children.length) {
          route.children = filterAsyncRouter(route.children, roles, role, account_type);
        }
        return true;
      } else {
        return false;
      }
    }
    // if (roles && roles.length) {
    //   console.log(route, 'route')
    //   if (route.meta && route.meta.roles && roles.includes(route.meta.roles)) {

    //     if (route.children && route.children.length) {
    //       route.children = filterAsyncRouter(route.children, roles, role, account_type);
    //     }
    //     route.isShow = true
    //   }
    //   // if (roles.includes(route.meta.roles)) {
    //   //   return true;
    //   // }
    // }
    if (roles.includes('assetManageSystem')) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles, role, account_type);
      }
      if (route.isLeader && account_type != 100) {
        return false;
      }
      return true;
    }
    if (role) {
      var roleList = role.split(',');

      //权限太多了，不再定义布尔值控制，用一个数组来控制
      var routeRole = route.meta ? route.meta.role : null;
      if (!routeRole || routeRole.length <= 0) {
        //没设置role字段表示 全部由权限
        if (route.children && route.children.length) {
          route.children = filterAsyncRouter(route.children, roles, role, account_type);
        }
        return true;
      }
      if (routeRole && routeRole.length > 0 && hasSamePermission(routeRole, roleList)) {
        console.log(route);
        if (route.children && route.children.length) {
          route.children = filterAsyncRouter(route.children, roles, role, account_type);
        }
        return true;
      }
    }
    if (route.fixed) {
      //固定在菜单栏，不受权限控制
      return true;
    }
    //if (hasPermission(roles, route)) {
    //  if (route.children && route.children.length) {
    //    route.children = filterAsyncRouter(route.children, roles, role, account_type)
    //  }
    //  return true
    //}
    return false;
  });
  return accessedRouters;
}
var permission = {
  state: {
    routers: constantRoutes,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: function SET_ROUTERS(state, routers) {
      state.addRouters = routers;
      state.routers = constantRoutes.concat(routers);
      console.log('state.routers', state.routers);
    }
  },
  actions: {
    GenerateRoutes: function GenerateRoutes(_ref, data) {
      var commit = _ref.commit;
      return new Promise(function (resolve) {
        var roles = data.roles,
          role = data.role,
          account_type = data.account_type;
        console.log('GenerateRoutes', roles, role);
        var accessedRouters = filterAsyncRouter(asyncRouterMap, roles, role, account_type);
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      });
    }
  }
};
export default permission;